import { render, staticRenderFns } from "./ModelOverviewSidePanel.vue?vue&type=template&id=452af7aa&scoped=true&"
import script from "./ModelOverviewSidePanel.vue?vue&type=script&lang=js&"
export * from "./ModelOverviewSidePanel.vue?vue&type=script&lang=js&"
import style0 from "./ModelOverviewSidePanel.vue?vue&type=style&index=0&id=452af7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452af7aa",
  null
  
)

export default component.exports